import React from 'react';
import SEO from '../components/SEO';

const Terms = () => {
  return (
    <div className="bg-[#050505] text-white" data-testid="terms-page">
      <SEO
        title="Terms of Use — Bronto Intelligence"
        description="Terms of Use governing access to and use of the Bronto Intelligence website and its associated platforms."
        path="/terms"
      />
      <section className="relative pt-20 pb-16 px-6 lg:px-10 overflow-hidden">
        <div className="aurora-bg" />
        <div className="relative z-10 max-w-4xl mx-auto">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40 mb-6">
            Legal
          </div>
          <h1 className="text-display text-5xl md:text-7xl mb-8">Terms of Use</h1>
          <p className="text-white/55">Last updated: {new Date().getFullYear()}</p>
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-32 border-t border-white/5 pt-16">
        <div className="max-w-4xl mx-auto space-y-12 text-white/75 leading-relaxed">
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Acceptance of Terms</h2>
            <p>
              By accessing or using the Bronto Intelligence website, you agree to these Terms of Use. If you do not agree, please discontinue use of the website.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Use of Content</h2>
            <p>
              All content on this website, including text, graphics, logos, and trademarks, is the property of Bronto Intelligence Private Limited or its licensors and is protected by applicable intellectual property laws. Content may not be reproduced, distributed, or used without prior written permission.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Trademarks</h2>
            <p>
              &quot;Bronto Intelligence&quot;, &quot;BrontoAI&quot;, and &quot;MSPConnect&quot; are trademarks associated with Bronto Intelligence Private Limited. Unauthorized use of these marks is prohibited.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">External Links</h2>
            <p>
              This website may contain links to external sites that are not operated by Bronto Intelligence. We are not responsible for the content or practices of any third-party sites.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Disclaimer</h2>
            <p>
              Content on this website is provided for general informational purposes. While we endeavor to keep information accurate and current, we make no representations or warranties about the completeness or reliability of any information.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Limitation of Liability</h2>
            <p>
              To the extent permitted by law, Bronto Intelligence Private Limited shall not be liable for any indirect, incidental, or consequential damages arising from the use of this website.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Changes to Terms</h2>
            <p>
              These Terms of Use may be updated from time to time. Continued use of the website constitutes acceptance of any revised terms.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Governing Law</h2>
            <p>
              These Terms of Use are governed by the applicable laws of India.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
